"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateJob = exports.clear = exports.addJob = exports.createJobsFailed = exports.createJobsSuccess = exports.createJobsRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/diaryentries/jobs");
function fetchRequest(diaryUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        diaryUuid,
        entryUuid
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(payload, diaryUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload,
        diaryUuid,
        entryUuid
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload, diaryUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload,
        diaryUuid,
        entryUuid
    };
}
exports.fetchFailed = fetchFailed;
const createJobsRequest = (diaryUuid, entryUuid, jobs) => ({
    type: ActionTypes.CREATE_JOBS_REQUEST,
    payload: {
        diaryUuid,
        entryUuid,
        jobs
    }
});
exports.createJobsRequest = createJobsRequest;
const createJobsSuccess = (payload) => {
    return {
        type: ActionTypes.CREATE_JOBS_SUCCESS,
        payload
    };
};
exports.createJobsSuccess = createJobsSuccess;
const createJobsFailed = (payload) => {
    return {
        type: ActionTypes.CREATE_JOBS_FAILED,
        payload
    };
};
exports.createJobsFailed = createJobsFailed;
const addJob = (payload) => ({
    type: ActionTypes.ADD_JOB,
    payload
});
exports.addJob = addJob;
const clear = () => {
    return {
        type: ActionTypes.CLEAR
    };
};
exports.clear = clear;
const updateJob = (job, jobId) => ({
    type: ActionTypes.UPDATE_JOB,
    payload: {
        job,
        jobId
    }
});
exports.updateJob = updateJob;
//# sourceMappingURL=jobs.js.map